import * as actionTypes from '../constants/actionTypes';
import {
  fromJS
} from 'immutable';
import moment from 'moment';

const initialState = fromJS({
  userCode: undefined,
  password: undefined,
  customerNumber: undefined,
  progressState: false,
  persistExpiresAt: moment().add(1, 'minutes').toDate()
});

export default function loginReducer(state = initialState, action) {

  switch (action.type) {
    case actionTypes.LOGIN_USER:
      return state.merge({
        userCode: action.userCode,
        password: action.password,
        customerNumber:action.customerNumber,
        recaptchaResponse: action.recaptchaResponse,
        progressState: true
      });
    case actionTypes.CHECK_OVER_USER:
      return state.merge({
        code: action.code,
        progressState: true
      });
    case actionTypes.SET_MENU:
      return state.merge({
        menu: action.menu
      });
    case actionTypes.LOGIN_USER_SUCCESS:
      return state.merge({
        token: action.token,
        name: action.name,
        userName: action.userName,
        password: undefined,
        progressState: false
      });
    case actionTypes.LOGIN_USER_ERROR:
      return state.merge({
        name: undefined,
        userName: undefined,
        menu: undefined,
        token: undefined,
        progressState: false
      });
    case actionTypes.LOGOUT_USER:
      return state.merge({
        name: undefined,
        userName: undefined,
        token: undefined,
        tokenError: undefined,
        timeoutId: undefined,
        code: undefined,
        menu: undefined,
        switchedUserId: undefined
      });
    case actionTypes.TOKEN_REFRESH_SUCCESS:
      return state.merge({
        token: action.token
      });
    case actionTypes.TOKEN_REFRESH_ERROR:
      return state.merge({
        name: undefined,
        userName: undefined,
        menu: undefined,
        token: undefined,
        tokenError: action.error
      });
    case actionTypes.TIMEOUT_CREATE:
      return state.merge({
        timeoutId: action.timeoutId
      });
    case actionTypes.CLEAR_LOGIN:
      return initialState;
    case actionTypes.SET_SWITCHED_USER:
      return state.merge({
        switchedUserId: action.userId
      });
    default:
      return state;
  }

}

